// views.app.rewards.redeem.default

export const DEFAULT_REDEEM = {
  title: 'Redeem Rewards',
  description: 'Redeem your reward points'
};
